import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  wizard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  content: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    minHeight: '500px',
  },
});